import {
  alipay,
  bancontact,
  bank,
  blik,
  boleto,
  cardAmex,
  cardApplePay,
  cardDefault,
  cardDiners,
  cardDiscover,
  cardGooglePay,
  cardJcb,
  cardMasterCard,
  cardUnionPay,
  cardVisa,
  cashapp,
  defaultPaymentMethod,
  eps,
  grabPay,
  ideal,
  mobilePay,
  sepa,
  weChatPay
} from './assets'

export const roleNames: { [key: number]: string } = {
  [0]: 'No_Account',
  [1]: 'Free',
  [2]: 'Unlimited',
  [3]: 'Hundred',
  [4]: 'Pro',
  [10]: 'Free_Unlimited'
}

export const images: { [key: string]: string } = {
  acss_debit: bank,
  alipay: alipay,
  amex: cardAmex,
  apple_pay: cardApplePay,
  au_becs_debit: bank,
  bacs_debit: bank,
  bancontact: bancontact,
  blik: blik,
  boleto: boleto,
  cashapp: cashapp,
  diners: cardDiners,
  discover: cardDiscover,
  eps: eps,
  google_pay: cardGooglePay,
  grabpay: grabPay,
  ideal: ideal,
  jcb: cardJcb,
  mastercard: cardMasterCard,
  mobile_pay: mobilePay,
  sepa_debit: sepa,
  unionpay: cardUnionPay,
  unknown: defaultPaymentMethod,
  unknownCard: cardDefault,
  us_bank_account: bank,
  visa: cardVisa,
  wechat_pay: weChatPay
}

export const paymentTypes: { [key: string]: string } = {
  alipay: 'Alipay',
  apple_pay: 'Apple Pay',
  bancontact: 'Bancontact',
  blik: 'Blik',
  boleto: 'Boleto',
  cashapp: 'Cash App',
  eps: 'EPS',
  google_pay: 'Google Pay',
  grabpay: 'GrabPay',
  ideal: 'iDEAL',
  mobile_pay: 'MobilePay',
  sepa_debit: 'SEPA Direct Debit',
  wechat_pay: 'WeChat Pay',
  '': ''
}

export enum PaymentMethodAction {
  CHANGE = 'change'
}
